// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root {
  background-repeat: no-repeat;
  display: inline-block;
  overflow: hidden;
  cursor: pointer;
}

.resize {
  border: 1px dashed #78a300;
  position: relative;
  max-width: 100%;
  display: inline-block;
  line-height: 0;
  top: -1px;
  left: -1px;
}

.resizeHandle {
  cursor: nwse-resize;
  position: absolute;
  z-index: 2;
  line-height: 1;
  bottom: -4px;
  right: -5px;
  border: 1px solid white;
  background-color: #78a300;
  width: 8px;
  height: 8px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/react-rte/lib/ui/ImageSpan.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,UAAU;EACV,WAAW;AACb","sourcesContent":[".root {\n  background-repeat: no-repeat;\n  display: inline-block;\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.resize {\n  border: 1px dashed #78a300;\n  position: relative;\n  max-width: 100%;\n  display: inline-block;\n  line-height: 0;\n  top: -1px;\n  left: -1px;\n}\n\n.resizeHandle {\n  cursor: nwse-resize;\n  position: absolute;\n  z-index: 2;\n  line-height: 1;\n  bottom: -4px;\n  right: -5px;\n  border: 1px solid white;\n  background-color: #78a300;\n  width: 8px;\n  height: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
